import styled from "styled-components";

export const StyledDDContainer = styled.div<{ customWidth?: number }>`
    position: relative;
    ${({ customWidth }) => customWidth && `width: ${customWidth}px;`}
`;

export const StyledContentFilter = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 263px;
    row-gap: 16px;
`;

export const StyledDownloadEngagementResultContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    flex-wrap: wrap;
`;
